import Dialog from './Dialog.view';

export default Dialog;
